import { gql } from '@apollo/client'
// graphql
import { PLAN_KPI_DETAILS_FRAGMENT } from 'graphql/planKPIs/queries'

export const PLAN_KPI_CREATE_MUTATION = gql`
  mutation PLAN_KPI_CREATE_MUTATION($input: PlanKPICreateInput!) {
    planKPICreate(input: $input) {
      ok
      data {
        id
        description
        createdAt
      }
    }
  }
`

export const PLAN_KPI_DELETE_MUTATION = gql`
  mutation PLAN_KPI_DELETE_MUTATION($id: ID!) {
    planKPIDelete(id: $id) {
      ok
    }
  }
`

export const PLAN_KPI_UPDATE_MUTATION = gql`
  mutation PLAN_KPI_UPDATE_MUTATION($id: ID!, $input: PlanKPIUpdateInput!) {
    planKPIUpdate(id: $id, input: $input) {
      ok
      data {
        ...PLAN_KPI_DETAILS
      }
    }
  }
  ${PLAN_KPI_DETAILS_FRAGMENT}
`

export const PLAN_KPI_SCALE_OPTION_CUD_MUTATION = gql`
  mutation PLAN_KPI_SCALE_OPTION_CUD_MUTATION($planKPIId: ID!, $input: [PlanKPIScaleOptionCUDInput]) {
    planKPIScaleOptionCUD(planKPIId: $planKPIId, input: $input) {
      ok
    }
  }
`
